define('lib/Podio.Statsd',['require','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Event.UI'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var eventUI = require('lib/Podio.Event.UI');

  function increment(key, count, async) {
    var params;

    count = count || 1;

    params = {
      requestData: {
        key: key,
        count: count
      },
      ajaxParams: { async: async || false }
    };

    return transport.postJSON(routes.statsd_increment_path(), params);
  }

  function onEnclosureElmClicked(elmTarget, e) {
    var eventName = elmTarget.data('tracking-statsd-event');
    var async = elmTarget.data('async');

    increment(eventName, null, async);
  }

  // Bind to anything inside the enclosures that needed to be tracked. Exclude forms and radio buttons.
  eventUI.bind('click', '*[data-tracking-statsd-event]:not(form, input[type=radio])', onEnclosureElmClicked, true);

  // Listen to form submits as well.
  eventUI.bind('submit', 'form[data-tracking-statsd-event]', onEnclosureElmClicked, true);

  // Listen to changing radio inputs as well.
  eventUI.bind('change', 'input[type="radio"][data-tracking-statsd-event]', onEnclosureElmClicked, true);

  return {
    increment: increment
  };

});

